import { CountryMaterialWIthNestedObjectsResponse } from '../../../../web-api-client';
import { CountryMaterial } from '../../models/country-material';

export const mapCountryFromMaterialResponse = (
  response: CountryMaterialWIthNestedObjectsResponse
): CountryMaterial => ({
  countryMaterialId: response.countryMaterialId ?? 0,
  countryId: response.country?.countryId ?? 0,
  name: response.country?.name ?? '',
  region: response.country?.region?.name ?? '',
  code: response.country?.code ?? '',
});
